// extracted by mini-css-extract-plugin
export var changeIcon = "_4h-4";
export var container = "_4h-0";
export var divider = "_4h-7";
export var externalLinkIcon = "_4h-1";
export var green = "_4h-5";
export var helpCircleIcon = "_4h-3";
export var iconButton = "_4h-2";
export var red = "_4h-6";